(() => {
  document.body.classList.add('goat-luxury-active');

  const slider = document.querySelector('[data-goat-slider]');
  if (slider) {
    const slides = [...slider.querySelectorAll('[data-goat-slide]')];
    const dots = [...slider.querySelectorAll('[data-goat-dot]')];
    const previous = slider.querySelector('[data-goat-prev]');
    const next = slider.querySelector('[data-goat-next]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let active = 0;
    let autoplay;

    const showSlide = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === active;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        slide.querySelectorAll('a, button').forEach((element) => { element.tabIndex = selected ? 0 : -1; });
        const video = slide.querySelector('video');
        if (video) {
          if (selected && !reducedMotion) video.play().catch(() => {});
          else video.pause();
        }
      });
      dots.forEach((dot, dotIndex) => {
        const selected = dotIndex === active;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    };

    const startAutoplay = () => {
      window.clearInterval(autoplay);
      if (!reducedMotion) autoplay = window.setInterval(() => showSlide(active + 1), 8000);
    };

    previous?.addEventListener('click', () => { showSlide(active - 1); startAutoplay(); });
    next?.addEventListener('click', () => { showSlide(active + 1); startAutoplay(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { showSlide(Number(dot.dataset.goatDot)); startAutoplay(); }));
    slider.addEventListener('mouseenter', () => window.clearInterval(autoplay));
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('focusin', () => window.clearInterval(autoplay));
    slider.addEventListener('focusout', startAutoplay);
    showSlide(0);
    startAutoplay();
  }

  const quiz = document.querySelector('[data-goat-quiz]');
  if (quiz) {
    const result = quiz.querySelector('[data-goat-result]');
    const catalog = quiz.querySelector('[data-goat-catalog]');
    const candidates = [...quiz.querySelectorAll('[data-goat-candidate]')];
    const styleTerms = {
      clean: ['minimal', 'field', 'shirt', 'coat', 'blazer', 'collarless', 'trench', 'signature'],
      bomber: ['bomber', 'aviator', 'flight', 'varsity', 'shearling'],
      moto: ['moto', 'biker', 'racer', 'riding', 'asymmetric']
    };
    const useTerms = {
      everyday: ['bomber', 'field', 'shirt', 'casual', 'minimal', 'signature'],
      riding: ['moto', 'biker', 'racer', 'riding', 'asymmetric'],
      occasion: ['coat', 'blazer', 'trench', 'suede', 'shirt', 'minimal', 'signature']
    };
    const includesAny = (copy, terms) => terms.some((term) => copy.includes(term));

    quiz.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(quiz);
      const who = data.get('for');
      const use = data.get('use');
      const style = data.get('style');
      const budget = data.get('budget');

      candidates.forEach((candidate) => { candidate.hidden = true; });
      let ranked = candidates
        .filter((candidate) => who === 'gift' || candidate.dataset.wearer === who)
        .filter((candidate) => {
          const price = Number(candidate.dataset.price || 0);
          if (budget === 'under20') return price <= 2000000;
          if (budget === '20to30') return price > 2000000 && price <= 3000000;
          return true;
        })
        .map((candidate, order) => {
          const copy = candidate.dataset.search || '';
          let score = 0;
          if (includesAny(copy, styleTerms[style] || [])) score += 5;
          if (includesAny(copy, useTerms[use] || [])) score += 3;
          if (copy.includes('signature')) score += 1;
          return {candidate, score, order, price: Number(candidate.dataset.price || 0)};
        })
        .sort((a, b) => b.score - a.score || a.price - b.price || a.order - b.order);

      if (!ranked.length) {
        if (catalog) catalog.hidden = true;
        result.innerHTML = '<strong>No exact jacket matches all four choices yet.</strong><span>We will not ignore your budget or show an irrelevant product. Use the private design studio below and we will build the closest fit.</span><a class="goat-text-link" href="#goat-bespoke">Enter the design studio →</a>';
        result.hidden = false;
        result.scrollIntoView({behavior: 'smooth', block: 'nearest'});
        return;
      }

      ranked.slice(0, 3).forEach(({candidate}) => { candidate.hidden = false; });
      if (catalog) catalog.hidden = false;
      const wearerLabel = who === 'women' ? "women's" : who === 'gift' ? 'gift-worthy' : "men's";
      result.innerHTML = `<strong>Your ${wearerLabel} private edit</strong><span>Ranked from the correct jacket collection by occasion, silhouette and investment. No bags or childrenswear are included.</span>`;
      result.hidden = false;
      result.scrollIntoView({behavior: 'smooth', block: 'nearest'});
    });
  }

  const studio = document.querySelector('[data-goat-bespoke]');
  if (studio) {
    const form = studio.querySelector('form');
    const steps = [...studio.querySelectorAll('[data-goat-step]')];
    const nav = [...studio.querySelectorAll('[data-goat-step-nav]')];
    const summaryField = studio.querySelector('[data-goat-summary]');
    const priceOutput = studio.querySelector('[data-goat-price]');
    const finalPriceOutput = studio.querySelector('[data-goat-final-price]');
    const materialInputs = [...studio.querySelectorAll('[data-material]')];
    const sizeSelect = studio.querySelector('[data-goat-size]');
    const complexitySelect = studio.querySelector('[data-goat-complexity]');
    const depositVariant = studio.dataset.depositVariant;
    let currentStep = 0;
    let jacketDataUrl = '';
    let jacketRemoteUrl = '';
    let personDataUrl = '';
    let currentEstimate = '';

    const showStep = (index) => {
      currentStep = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach((step, stepIndex) => {
        const selected = stepIndex === currentStep;
        step.hidden = !selected;
        step.classList.toggle('is-active', selected);
      });
      nav.forEach((button, buttonIndex) => {
        button.classList.toggle('is-active', buttonIndex === currentStep);
        button.classList.toggle('is-complete', buttonIndex < currentStep);
        button.setAttribute('aria-current', buttonIndex === currentStep ? 'step' : 'false');
      });
    };

    const validateStep = () => {
      const current = steps[currentStep];
      const fields = [...current.querySelectorAll('input[required], select[required], textarea[required]')];
      for (const field of fields) {
        if (!field.checkValidity()) {
          field.reportValidity();
          return false;
        }
      }
      if (currentStep === 0) {
        const reference = form?.querySelector('input[name="contact[reference]"]');
        if (!reference?.value && !jacketDataUrl) {
          reference?.setCustomValidity('Add a public image link or upload the jacket reference.');
          reference?.reportValidity();
          reference?.addEventListener('input', () => reference.setCustomValidity(''), {once: true});
          return false;
        }
      }
      return true;
    };

    studio.querySelectorAll('[data-goat-next]').forEach((button) => button.addEventListener('click', () => {
      if (validateStep()) showStep(currentStep + 1);
    }));
    studio.querySelectorAll('[data-goat-back]').forEach((button) => button.addEventListener('click', () => showStep(currentStep - 1)));
    nav.forEach((button, index) => button.addEventListener('click', () => { if (index < currentStep) showStep(index); }));

    const readUpload = (input, onLoaded, label) => {
      const file = input?.files?.[0];
      if (!file) return;
      if (file.size > 8 * 1024 * 1024) {
        input.value = '';
        if (label) label.textContent = 'Please choose an image smaller than 8 MB';
        return;
      }
      const reader = new FileReader();
      reader.addEventListener('load', () => onLoaded(String(reader.result), file));
      reader.readAsDataURL(file);
    };

    const jacketUpload = studio.querySelector('[data-goat-upload]');
    const jacketLabel = studio.querySelector('[data-goat-upload-label]');
    const jacketPreview = studio.querySelector('[data-goat-upload-preview]');
    const jacketPreviewImage = jacketPreview?.querySelector('img');
    const removeJacket = studio.querySelector('[data-goat-upload-remove]');
    const tryon = studio.querySelector('[data-goat-tryon]');
    const tryonJacket = studio.querySelector('[data-goat-jacket-preview]');
    const tryonPerson = studio.querySelector('[data-goat-person-preview]');
    const jacketFigure = studio.querySelector('[data-goat-jacket-figure]');
    const personFigure = studio.querySelector('[data-goat-person-figure]');
    const jacketLinkCard = studio.querySelector('[data-goat-jacket-link-card]');
    const instagramEmbed = studio.querySelector('[data-goat-instagram-embed]');
    const jacketDomain = studio.querySelector('[data-goat-jacket-domain]');
    const referenceInput = studio.querySelector('[data-goat-reference-url]');
    const referenceStatus = studio.querySelector('[data-goat-reference-status]');

    const isDirectImageUrl = (value) => {
      try {
        const pathname = new URL(value).pathname.toLowerCase();
        return /\.(jpe?g|png|webp|avif|gif)$/.test(pathname);
      } catch (error) {
        return false;
      }
    };

    const referenceDomain = (value) => {
      try { return new URL(value).hostname.replace(/^www\./, ''); }
      catch (error) { return 'Public page link'; }
    };

    const instagramEmbedUrl = (value) => {
      try {
        const url = new URL(value);
        if (!/(^|\.)instagram\.com$/i.test(url.hostname)) return '';
        const match = url.pathname.match(/^\/(p|reel|tv)\/([^/]+)/i);
        if (!match) return '';
        return `https://www.instagram.com/${match[1].toLowerCase()}/${match[2]}/embed/`;
      } catch (error) {
        return '';
      }
    };

    const refreshTryon = () => {
      const referenceUrl = referenceInput?.value.trim() || '';
      const jacketVisual = jacketDataUrl || jacketRemoteUrl;
      const instagramUrl = !jacketDataUrl ? instagramEmbedUrl(referenceUrl) : '';
      const hasJacketReference = Boolean(jacketVisual || instagramUrl || referenceUrl);
      if (tryonJacket) {
        tryonJacket.hidden = !jacketVisual;
        if (jacketVisual) tryonJacket.src = jacketVisual;
        else tryonJacket.removeAttribute('src');
      }
      if (instagramEmbed) {
        instagramEmbed.hidden = !instagramUrl;
        if (instagramUrl && instagramEmbed.src !== instagramUrl) instagramEmbed.src = instagramUrl;
        else if (!instagramUrl) instagramEmbed.removeAttribute('src');
      }
      if (jacketLinkCard) jacketLinkCard.hidden = Boolean(jacketVisual || instagramUrl) || !referenceUrl;
      if (jacketDomain && referenceUrl) jacketDomain.textContent = referenceDomain(referenceUrl);
      if (jacketFigure) {
        jacketFigure.hidden = !hasJacketReference;
        jacketFigure.classList.toggle('is-instagram', Boolean(instagramUrl));
      }
      if (tryonPerson) {
        tryonPerson.hidden = !personDataUrl;
        if (personDataUrl) tryonPerson.src = personDataUrl;
        else tryonPerson.removeAttribute('src');
      }
      if (personFigure) personFigure.hidden = !personDataUrl;
      if (tryon) {
        tryon.hidden = !(hasJacketReference || personDataUrl);
        tryon.classList.toggle('is-single', Number(hasJacketReference) + Number(Boolean(personDataUrl)) === 1);
      }
    };

    const syncReferenceUrl = () => {
      const value = referenceInput?.value.trim() || '';
      jacketRemoteUrl = !jacketDataUrl && isDirectImageUrl(value) ? value : '';
      const instagramUrl = !jacketDataUrl ? instagramEmbedUrl(value) : '';
      if (referenceStatus) {
        if (!value) referenceStatus.textContent = 'Direct JPG, PNG and WebP links preview instantly. Page and video links are saved in your brief for specialist review.';
        else if (jacketRemoteUrl) referenceStatus.textContent = 'Direct image detected. Loading the visual preview…';
        else if (instagramUrl) referenceStatus.textContent = 'Public Instagram reference detected. Loading Instagram’s official visual embed…';
        else referenceStatus.textContent = 'Page link saved. Browsers cannot reliably extract an image from every film, video or social page; upload the image itself for an instant preview.';
      }
      refreshTryon();
    };

    referenceInput?.addEventListener('input', syncReferenceUrl);
    referenceInput?.addEventListener('change', syncReferenceUrl);
    tryonJacket?.addEventListener('load', () => {
      if (referenceStatus && jacketRemoteUrl) referenceStatus.textContent = 'Direct image loaded and added to your reference board.';
    });
    instagramEmbed?.addEventListener('load', () => {
      if (referenceStatus && instagramEmbedUrl(referenceInput?.value.trim() || '')) referenceStatus.textContent = 'Instagram reference loaded. The post is visible to you and included in the design brief.';
    });
    tryonJacket?.addEventListener('error', () => {
      if (!jacketRemoteUrl) return;
      jacketRemoteUrl = '';
      if (referenceStatus) referenceStatus.textContent = 'That website blocked image previewing. The URL is still saved; upload the image itself to see it immediately.';
      refreshTryon();
    });

    jacketUpload?.addEventListener('change', () => readUpload(jacketUpload, (url, file) => {
      jacketDataUrl = url;
      jacketRemoteUrl = '';
      if (jacketPreviewImage) jacketPreviewImage.src = url;
      if (jacketPreview) jacketPreview.hidden = false;
      if (jacketLabel) jacketLabel.textContent = file.name;
      refreshTryon();
    }, jacketLabel));
    removeJacket?.addEventListener('click', () => {
      jacketDataUrl = '';
      jacketUpload.value = '';
      jacketPreviewImage?.removeAttribute('src');
      if (jacketPreview) jacketPreview.hidden = true;
      if (jacketLabel) jacketLabel.textContent = 'Choose JPG, PNG or WebP · maximum 8 MB';
      syncReferenceUrl();
    });

    const personUpload = studio.querySelector('[data-goat-person-upload]');
    const personLabel = studio.querySelector('[data-goat-person-label]');
    personUpload?.addEventListener('change', () => readUpload(personUpload, (url, file) => {
      personDataUrl = url;
      if (personLabel) personLabel.textContent = file.name;
      refreshTryon();
    }, personLabel));

    const priceBands = {
      sheep: {min: 18000, max: 26000, label: 'Sheepskin'},
      buffalo: {min: 25000, max: 35000, label: 'Buffalo hide'},
      suede: {min: 25000, max: 35000, label: 'Suede'}
    };
    const sizeWeight = {S: 0, M: 0.1, L: 0.22, XL: 0.38, '2XL': 0.55, '3XL': 0.72, '4XL': 0.86};
    const complexityWeight = {clean: 0, detailed: 0.08, screen: 0.14};
    const money = (value) => new Intl.NumberFormat('en-IN', {style: 'currency', currency: 'INR', maximumFractionDigits: 0}).format(value);

    const updateEstimate = () => {
      const material = materialInputs.find((input) => input.checked)?.dataset.material;
      const size = sizeSelect?.value;
      const complexity = complexitySelect?.value || 'clean';
      if (!material || !size) {
        currentEstimate = '';
        if (priceOutput) priceOutput.textContent = 'Choose leather and size';
        if (finalPriceOutput) finalPriceOutput.textContent = 'Complete leather and size choices';
        return;
      }
      const band = priceBands[material];
      const weight = Math.min(1, (sizeWeight[size] || 0) + (complexityWeight[complexity] || 0));
      const price = Math.round((band.min + (band.max - band.min) * weight) / 500) * 500;
      currentEstimate = `${money(price)} estimated · ${band.label} · size ${size}`;
      if (priceOutput) priceOutput.textContent = currentEstimate;
      if (finalPriceOutput) finalPriceOutput.textContent = currentEstimate;
    };
    materialInputs.forEach((input) => input.addEventListener('change', updateEstimate));
    sizeSelect?.addEventListener('change', updateEstimate);
    complexitySelect?.addEventListener('change', updateEstimate);

    const buildSummary = () => {
      const value = (name) => form?.querySelector(`[name="${name}"]`)?.value || 'Not supplied';
      const jacketName = jacketUpload?.files?.[0]?.name || 'No local file';
      const personName = personUpload?.files?.[0]?.name || 'No local file';
      return [
        'GOAT PRIVATE DESIGN STUDIO BRIEF',
        `Reference URL: ${value('contact[reference]')}`,
        `Reference filename: ${jacketName}`,
        `Wearer: ${value('contact[wearer]')}`,
        `Occasion: ${value('contact[occasion]')}`,
        `Leather: ${value('contact[material]')}`,
        `Size: ${value('contact[size]')}`,
        `Complexity: ${value('contact[complexity]')}`,
        `Working estimate: ${currentEstimate || 'Pending selections'}`,
        `Try-on photo filename: ${personName}`,
        `Design notes: ${value('contact[design_notes]')}`,
        'Customer has been shown the approximation disclaimer. Please call within one working day.'
      ].join('\n');
    };

    form?.addEventListener('submit', () => { if (summaryField) summaryField.value = buildSummary(); });

    const payButton = studio.querySelector('[data-goat-pay]');
    payButton?.addEventListener('click', async () => {
      if (!depositVariant || !validateStep()) return;
      payButton.disabled = true;
      payButton.textContent = 'Preparing secure checkout…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            items: [{
              id: Number(depositVariant),
              quantity: 1,
              properties: {'Design studio brief': buildSummary(), 'Working estimate': currentEstimate}
            }]
          })
        });
        if (!response.ok) throw new Error('Could not prepare checkout');
        window.location.href = '/checkout';
      } catch (error) {
        payButton.disabled = false;
        payButton.textContent = 'Checkout unavailable · submit the brief instead';
      }
    });

    document.querySelectorAll('[data-goat-inspiration]').forEach((link) => link.addEventListener('click', () => {
      const notes = form?.querySelector('textarea[name="contact[design_notes]"]');
      if (notes && !notes.value) notes.value = link.dataset.goatInspiration || '';
      showStep(0);
    }));

    const screenBrief = document.querySelector('[data-goat-screen-brief]');
    screenBrief?.addEventListener('submit', (event) => {
      event.preventDefault();
      const query = screenBrief.querySelector('[data-goat-screen-query]')?.value.trim() || '';
      const url = screenBrief.querySelector('[data-goat-screen-url]')?.value.trim() || '';
      if (!query && !url) {
        screenBrief.querySelector('input')?.focus();
        return;
      }
      const notes = form?.querySelector('textarea[name="contact[design_notes]"]');
      if (notes) notes.value = `Screen inspiration: ${query || 'See supplied link'}. Reinterpret the silhouette as an original GOAT design without protected logos or costume marks.`;
      if (referenceInput && url) referenceInput.value = url;
      syncReferenceUrl();
      showStep(0);
      studio.scrollIntoView({behavior: 'smooth', block: 'start'});
    });

    syncReferenceUrl();
    showStep(0);
  }
})();
